import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Router } from '@angular/router'

import { Message } from '../models/message.model'
import { ErrorEnum } from '../models/error.enum'
import { AppError } from '../models/error.model'

/**
 * Class responsible for generating local SfMessage objects
 */
@Injectable()
export class MessageService {
  // eslint-disable-next-line no-useless-constructor
  constructor(private translate: TranslateService, private router: Router) {}

  /**
   * Returns the Error object associated to a local error code
   */
  public getErrorForLocaleCode(code: ErrorEnum): AppError {
    const tError = new AppError(
      code.valueOf(),
      this.translate.instant('ERROR.NOT_AUTHENTICATED'),
      true,
      true
    )
    switch (code) {
      case ErrorEnum.no_network:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.NO_NETWORK'),
          true,
          true
        )
      case ErrorEnum.internal_error:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.INTERNAL'),
          true,
          false
        )
      case ErrorEnum.bad_request:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.BAD_REQUEST'),
          true,
          false
        )
      case ErrorEnum.not_authenticated:
        // By default an authentication error should allow user to reconnect

        tError.retryLabel = this.translate.instant('DIALOG.RECONNECT')
        tError.retryAction = () => {
          this.router.navigate(['/login'])
        }
        return tError
      case ErrorEnum.not_authorized:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.NOT_AUTHORIZED'),
          true,
          false
        )
      case ErrorEnum.not_found:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.NOT_FOUND'),
          true
        )
      case ErrorEnum.teapot:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.TEAPOT'),
          true,
          true
        )
      case ErrorEnum.malformed_json:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.MALFORMED_JSON'),
          true,
          true
        )
      case ErrorEnum.research_incomplete:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.RESEARCH_INCOMPLETE'),
          true
        )
      case ErrorEnum.user_not_found:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.USER_NOT_FOUND'),
          true
        )
      default:
        return new AppError(
          code.valueOf(),
          this.translate.instant('ERROR.UNDEFINED'),
          true
        )
    }
  }

  /**
   * Get an SfMessage object that is actually not a error but an information.
   */
  public getMessage(msg: string): Message {
    return new Message(msg)
  }
}
